/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

const BASE_PATH = 'publisherinfo';

/** Angular DI token for the PublisherInfo HTTP resource (factory product). */
export class PublisherInfoResource {
}

export function createPublisherInfoResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);

  function get(pathSuffix: string, paramName: string, id: any): Promise<any> {
    const uri = ApiConfig.obtain().getVersionedUri([BASE_PATH, pathSuffix]);
    return send({method: 'GET', url: uri, params: {[paramName]: id}});
  }

  return {
    order: function(orderId: any): Promise<any> {
      return get('order', 'order', orderId);
    },
    lineItem: function(lineItemId: any): Promise<any> {
      return get('lineitem', 'lineItem', lineItemId);
    },
    advertiser: function(advertiserId: any): Promise<any> {
      return get('advertiser', 'advertiser', advertiserId);
    }
  };
}

export const publisherInfoResourceProvider = {
  provide: PublisherInfoResource,
  useFactory: createPublisherInfoResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService]
};

